// extracted by mini-css-extract-plugin
module.exports = {"managerSelect":"styles_managerSelect__29Fk-"};